import React from 'react';
import { ILoginExpert } from '../../api/ApiClient';
import { connect } from 'react-redux';
import { AuthenticationForm } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';

const LoginContainer = ({ apiError, onLogin }: Props) => (
    <AuthenticationForm
      apiError={apiError}
      onLogin={data => onLogin(data as ILoginExpert)}
      withPhone
    />
);

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onLogin: dispatch.auth.login,
});

export default connect(mapState, mapDispatch)(LoginContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps;
